/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal hotel data for link preview metadata (no auth).
 * @export
 * @interface HotelMetadata
 */
export interface HotelMetadata {
    /**
     * Hotel display name
     * @type {string}
     * @memberof HotelMetadata
     */
    propertyName?: string;
    /**
     * Guest rating (e.g. 0-5 scale, frontend may display as 0-10)
     * @type {number}
     * @memberof HotelMetadata
     */
    averageGuestRating?: number;
    /**
     * URL for og:image (hero or first non-room image)
     * @type {string}
     * @memberof HotelMetadata
     */
    firstImageUrl?: string;
}

/**
 * Check if a given object implements the HotelMetadata interface.
 */
export function instanceOfHotelMetadata(value: object): value is HotelMetadata {
    return true;
}

export function HotelMetadataFromJSON(json: any): HotelMetadata {
    return HotelMetadataFromJSONTyped(json, false);
}

export function HotelMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyName': json['property_name'] == null ? undefined : json['property_name'],
        'averageGuestRating': json['average_guest_rating'] == null ? undefined : json['average_guest_rating'],
        'firstImageUrl': json['first_image_url'] == null ? undefined : json['first_image_url'],
    };
}

export function HotelMetadataToJSON(json: any): HotelMetadata {
    return HotelMetadataToJSONTyped(json, false);
}

export function HotelMetadataToJSONTyped(value?: HotelMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_name': value['propertyName'],
        'average_guest_rating': value['averageGuestRating'],
        'first_image_url': value['firstImageUrl'],
    };
}

